module.exports = __webpack_public_path__ + "img/oneid-4.8983d8f9.png";